import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type ParamsDTO = {
  uuid: string
  toggle: string
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const useRfqQuotePauseMutation = () =>
  useMutation<any, ErrorDTO, ParamsDTO>({
    mutationFn: async (params: ParamsDTO) => {
      try {
        const res = await client.put(
          `/rfq/quote/pause/${params.toggle}/${params.uuid}`
        )

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
